import React from "react";
import Marquee from "react-fast-marquee";

import { ReactComponent as Bulb } from "../../assets/bulb-emoji.svg";
import { ReactComponent as Angular } from "../../assets/angular.svg";
import { ReactComponent as GCP } from "../../assets/gcp.svg";
import { ReactComponent as JS } from "../../assets/javascript.svg";
import { ReactComponent as Node } from "../../assets/nodejs.svg";
import { ReactComponent as Postgresql } from "../../assets/postgresql.svg";
import { ReactComponent as ReactIcon } from "../../assets/react.svg";
import { ReactComponent as Sass } from "../../assets/sass.svg";
import { ReactComponent as TS } from "../../assets/typescript.svg";

import "./TechStack.scss";

const TechStack = () => {
  return (
    <div className="tech-stack">
      <p>
        My Tech Stack <Bulb className="svg-title-icon" />{" "}
      </p>
      <Marquee pauseOnHover>
        <JS className="tech-stack-item" />
        <TS className="tech-stack-item" />
        <Node className="tech-stack-item" />
        <Angular className="tech-stack-item" />
        <ReactIcon className="tech-stack-item" />
        <Sass className="tech-stack-item" />
        <Postgresql className="tech-stack-item" />
        <GCP className="tech-stack-item" />
      </Marquee>
    </div>
  );
};

export default TechStack;
